import dayjs from 'dayjs'
import TrackProAPI from './track-pro-api'

export const getUserNotifications = (dateRange: {startDate:Date, endDate:Date}) => {
    const startFormattedDate = dayjs(dateRange.startDate).format('l')
    const endFormattedDate = dayjs(dateRange.endDate).format('l')
    
    const endpoint = dateRange
        ? `/user/notifications?start_date=${startFormattedDate}&end_date=${endFormattedDate}`
        : '/user/notifications'
    return TrackProAPI.get(endpoint)
}

export const deleteSingleNotification = async (notification_id: any) => {
    const { data } = await TrackProAPI.delete('/user/notifications', {
        data: { notification_id },
    })
    return data
}

export const clearNotifications = () => {
    return TrackProAPI.delete('/user/notifications/deleteAll')
}
